export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6641.dfe4d50f.jpg";